export default {"src":"/_next/static/media/arrow-icon-black.6a96da6a.svg","height":10,"width":23};